import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as io from 'socket.io-client';
import { environment } from 'src/environments/environment';
import { socketConnection, socketDisconnection } from '../store/actions/socket.actions';

interface SocketClient {
  on: (event: string, callback: (...args: any[]) => void) => void;
  emit: (event: string, payload?: any) => void;
  connect: () => void;
  disconnect: () => void;
}

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  public io: SocketClient;
  private readonly socketsDisabled = true;

  constructor(
    private store: Store,
  ) {
    // Temporarily disable socket
    if (this.socketsDisabled) {
      this.io = this.createNoopClient();
      this.store.dispatch(socketDisconnection());
      return;
    }

    this.io = io(environment.socketUrl);
    this.io.on('connect', () => {
      this.store.dispatch(socketConnection());
    });
    this.io.on('error', (_reason: string) => {
      this.store.dispatch(socketDisconnection());
    });
    this.io.on('connect_error', (_reason: Error) => {
      this.store.dispatch(socketDisconnection());
      setTimeout(() => {
        this.io.connect();
      }, 1000);
    });
    this.io.on('disconnect', (reason: string) => {
      if (reason === 'io server disconnect') {
        this.io.connect();
      }
      this.store.dispatch(socketDisconnection());
    });
  }

  private createNoopClient(): SocketClient {
    return {
      on: (_event: string, _callback: (...args: any[]) => void) => undefined,
      emit: (_event: string, _payload?: any) => undefined,
      connect: () => undefined,
      disconnect: () => undefined,
    };
  }
}
